import { Badge, Button, ConfigProvider, Layout, Tooltip, Select } from 'antd';
import { BellOutlined, LogoutOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAuth } from '../Login/AuthProvider';
import { toggleHistory } from '../../slices/historySlice';
import './CustomHeader.scss';
import { fetchCustomers, setSelectedCustomer } from '../../slices/customersSlice';
import { fetchLocations } from '../../slices/locationSlice';
import { fetchTemplates } from '../../slices/templatesSlice';
import { fetchEvents } from '../../slices/eventSlice';
import { fetchUsers } from '../../slices/usersSlice';
import { fetchImages } from '../../slices/imagesSlice';
import { fetchAccessPointData, fetchLabelData } from '../../slices/homeSlice';
import { fetchSchedules } from '../../slices/scheduleSlice';
import store from '../../store';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { getData } from '../../service/APIClient';
import { URL_MANUAL } from '../../service/endpoints';
import { useNotification } from '../../Helper/NotificationProvider';

const { Header } = Layout;

function CustomHeader() {
  const dispatch = useDispatch();
  const { logout } = useAuth();
  const unreadCount = useSelector(state => state.history.unreadCount);
  const customers = useSelector(state => state.customers.data);
  const customerStatus = useSelector(state => state.customers.status);
  const selectedCustomer = useSelector(state => state.customers.selectedCustomer);
  const root = document.documentElement;
  const primaryColor = getComputedStyle(root)
    .getPropertyValue('--primary-color')
    .trim();
  const { openNotification, contextHolder } = useNotification();

  const user = store.getState().auth.user;

  useEffect(() => {
    const getCustomers = async () => {
      if (customerStatus === 'idle') {
        await dispatch(fetchCustomers());
      }
      if(!selectedCustomer && customers.length > 0) {
        const customerId = user?.tenantId;
        dispatch(setSelectedCustomer(customerId))
      }
    }
    getCustomers()
  }, [customers]);

  const handleCustomerChange = (value) => {
    dispatch(setSelectedCustomer(value));
    dispatch(fetchLocations());
    dispatch(fetchCustomers());
    dispatch(fetchTemplates());
    dispatch(fetchEvents());
    dispatch(fetchUsers());
    dispatch(fetchImages());
    dispatch(fetchLabelData());
    dispatch(fetchAccessPointData());
    dispatch(fetchSchedules());
  }

  const downloadGuide = async () => {
    try{
      const manualLink = await getData(URL_MANUAL);
      const response = await fetch(manualLink.url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'Benutzerhandbuch.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      openNotification(
        'bottomRight',
        "Fehler",
        "Fehler beim Herunterladen des Handbuchs.",
        false
      );
    }

  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: primaryColor,
          colorSecondary: "#afafaf"
        }
      }}
    >
      <Header className="container-header-1">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1
          }}
        >
          <img src={"/images/schneeweiss_logo.png"}
               alt="Logo"
               style={{ width: 150 }} />
        </div>
          <div style={{ display: 'flex', alignItems: 'center', lineHeight: '0px' }}>
            {user?.role === 'admin' &&
              <Select
                placeholder="Kunde auswählen"
                style={{ width: 200, marginRight: 10 }}
                value={customers.length > 0 ? selectedCustomer : null}
                onChange={handleCustomerChange}
                options={customers.map(customer => ({
                  label: customer.name,
                  value: customer.key
                }))}
              >
                {selectedCustomer}
              </Select>
            }
            <Tooltip title="Benachrichtigungen">
              <Button
                style={{ marginRight: 10 }}
                shape="circle"
                onClick={() => dispatch(toggleHistory())}
              >
                <Badge size="default" count={unreadCount} offset={[5, -5]}>
                  <BellOutlined />
                </Badge>
              </Button>
            </Tooltip>
            <Tooltip title="Benutzerhandbuch">
              <Button
                style={{ marginRight: 10 }}
                shape="circle"
                onClick={downloadGuide}
              >
                <AutoStoriesIcon fontSize={"small"}/>
              </Button>
            </Tooltip>
          </div>
        <Tooltip title="Ausloggen">
          <Button
            style={{ boxShadow: 'none' }}
            type="primary"
            shape="circle"
            icon={<LogoutOutlined />}
            onClick={() => {
              const customerId = user?.tenantId;
              const currentCustomer = customers.find((customer) => customer.key === customerId);
              if(currentCustomer)
                dispatch(setSelectedCustomer(currentCustomer?.key))
              logout();
            }}
          />
        </Tooltip>
      </Header>
    </ConfigProvider>
  );
}

export default CustomHeader;
